export const BRAND = "Hydra Power";
export const TAGLINE = "Ritual botánico para pies renovados";

export const IMAGES = {
  heroTexture:
    "https://images.pexels.com/photos/6496462/pexels-photo-6496462.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  grass:
    "https://images.pexels.com/photos/2998999/pexels-photo-2998999.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  flowers:
    "https://images.unsplash.com/photo-1519415510236-718bdfcd89c8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  jars:
    "https://images.pexels.com/photos/8490112/pexels-photo-8490112.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
  spa:
    "https://images.pexels.com/photos/32203052/pexels-photo-32203052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700",
};

// Fotos reales del producto (subidas por el cliente)
export const PRODUCTS = {
  single: "/assets/products/product-single.webp", // frasco solo (sin fondo)
  duo: "/assets/products/product-duo.webp",       // frasco + caja (sin fondo)
  trio: "/assets/products/product-trio.webp",     // caja + frasco + caja (fondo blanco)
  pack3: "/assets/products/product-pack3.webp",   // composición 3 frascos (fondo oscuro)
};

export const CHAPTERS = [
  {
    n: "01",
    title: "Resequedad",
    body:
      "La piel deshidratada se agrieta y pierde elasticidad. Nuestro complejo botánico repone la barrera de humedad en profundidad desde la primera aplicación.",
    img: IMAGES.grass,
  },
  {
    n: "02",
    title: "Grietas y talones ásperos",
    body:
      "Manteca de karité y urea vegetal suavizan las zonas endurecidas, reparando grietas y devolviendo una textura sedosa a los talones.",
    img: IMAGES.flowers,
  },
  {
    n: "03",
    title: "Cansancio y pesadez",
    body:
      "Extractos de menta y aloe generan una sensación de frescura inmediata que alivia la fatiga tras largas jornadas de pie.",
    img: IMAGES.jars,
  },
];

export const SERVICES = [
  {
    t: "Hidratación 24h",
    d: "Una fórmula de liberación prolongada que mantiene tus pies suaves durante todo el día.",
  },
  {
    t: "Ingredientes botánicos",
    d: "Karité, aloe, menta y aceites esenciales de origen natural. Sin parabenos.",
  },
  {
    t: "Absorción rápida",
    d: "Textura ligera que no deja sensación grasa. Lista para calzarte al instante.",
  },
  {
    t: "Dermatológicamente probada",
    d: "Testada bajo control dermatológico para todo tipo de piel, incluso la más sensible.",
  },
];

export const OFFERS = [
  {
    id: "x1",
    name: "Ritual Individual",
    units: "1 Crema",
    price: "59.000",
    per: "$59.000 c/u",
    highlight: false,
    img: PRODUCTS.single,
    perks: ["1 unidad de Hydra Power 55g", "Guía de aplicación", "Envío nacional"],
  },
  {
    id: "x3",
    name: "Ritual Familiar",
    units: "3 Cremas",
    price: "96.000",
    per: "$32.000 c/u",
    highlight: true,
    badge: "Mejor valor",
    img: PRODUCTS.pack3,
    perks: [
      "3 unidades de Hydra Power 55g",
      "Ahorra $81.000",
      "Guía + neceser de regalo",
      "Envío gratis prioritario",
    ],
  },
  {
    id: "x2",
    name: "Ritual en Pareja",
    units: "2 Cremas",
    price: "80.000",
    per: "$40.000 c/u",
    highlight: false,
    img: PRODUCTS.duo,
    perks: ["2 unidades de Hydra Power 55g", "Ahorra $38.000", "Envío gratis"],
  },
];

export const TESTIMONIALS = [
  {
    q: "Tenía los talones agrietados desde hacía años. En dos semanas mis pies se sienten como nuevos.",
    a: "Carolina M.",
    r: "Medellín",
  },
  {
    q: "La sensación de frescura al final del día no tiene precio. Se absorbe rapidísimo.",
    a: "Andrés G.",
    r: "Bogotá",
  },
  {
    q: "El aroma es delicado y natural. Ahora es parte de mi rutina de noche obligatoria.",
    a: "Valentina R.",
    r: "Cali",
  },
  {
    q: "Compré el pack de 3 para mi familia. A todos nos encantó, repetiremos seguro.",
    a: "Jorge T.",
    r: "Barranquilla",
  },
];
